<script lang="ts" setup>
import Page from './Page.vue'
</script>

<template>
  <div>
    <Page :is-full-width="true">
      <template #header>
        <div>
          <LayoutHeader />
        </div>
      </template>
      <slot />
    </Page>
  </div>
</template>
